export enum REGULARLY_INDICATOR {
  DAILY = 'daily',
  WEEKDAYS = 'weekDays-',
  MONTHDAYS = 'monthDays-',
  INTERVAL = 'dayInterval-',
}
